module.exports = __webpack_public_path__ + "static/anniversary-4x-1d2c04a3b817a5ad728219e38971a7b9.png";